const component = "category-creation-form";

export const categoryCreationForm = {
  input: `${component}/input`,
  confirmButton: `${component}/confirm-button`,
  cancelButton: `${component}/cancel-button`,
};
